/* eslint-disable @typescript-eslint/no-explicit-any */
import { ErrorHandler, Injectable } from '@angular/core';
import * as StackTrace from 'stacktrace-js';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';
import { Preferences } from '@capacitor/preferences';
import { environment } from 'src/environments/environment';
import { Capacitor } from '@capacitor/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  async handleError(error: any): Promise<void> {
    console.error('An error occurred in GlobalErrorHandler:', error);
    try {
      // Retrieve the user ID from preferences
      const { value } = await Preferences.get({ key: 'USER_DATA' });
      const userData = value ? JSON.parse(value) : null;
      // Capture the stack trace from the error
      const stacktrace = await StackTrace.fromError(error);

      // Only use Firebase Crashlytics on native platforms
      if (Capacitor.isNativePlatform()) {
        if (userData && userData._id && userData?._id.$oid) {
          const userId = userData?._id.$oid;

          // Set the user ID in Crashlytics
          try {
            await FirebaseCrashlytics.setUserId({ userId });
            console.log('Error reported to Crashlytics:', error);
          } catch (crashlyticsError) {
            console.warn('Failed to set user ID in Crashlytics:', crashlyticsError);
          }
        } else {
          console.warn('User ID not found, error not reported to Crashlytics');
        }
      } else {
        console.log('Running on web platform, skipping Crashlytics reporting');
      }

      if (!environment.production && error.message !== 'Location services are not enabled') {
        console.log({
          message: error.message || 'Unknown error',
          stacktrace: stacktrace.map((trace: any) => ({
            functionName: trace.functionName,
            fileName: trace.fileName,
            lineNumber: trace.lineNumber,
            columnNumber: trace.columnNumber,
          })),
        })

        alert(JSON.stringify({
          message: error.message || 'Unknown error',
          stacktrace: stacktrace.map((trace: any) => ({
            functionName: trace.functionName,
            fileName: trace.fileName,
            lineNumber: trace.lineNumber,
            columnNumber: trace.columnNumber,
          })),
        }))

      }

      if (error.message !== 'Location services are not enabled' && Capacitor.isNativePlatform()) {
        // Log the error and stack trace to Crashlytics only on native platforms
        try {
          await FirebaseCrashlytics.recordException({
            message: error.message || 'Unknown error',
            stacktrace: stacktrace.map((trace: any) => ({
              functionName: trace.functionName,
              fileName: trace.fileName,
              lineNumber: trace.lineNumber,
              columnNumber: trace.columnNumber,
            })),
          });
        } catch (crashlyticsError) {
          console.warn('Failed to record exception in Crashlytics:', crashlyticsError);
        }
      }
    } catch (reportingError) {
      console.error('Failed to report error to Crashlytics:', reportingError);
    }
  }
}
